import { passwordChangeAtom } from '@/interfaces/auth';
import { buttonBaseStyle } from '@/styles/constant';
import { Button, Dialog, TextField, Typography } from '@mui/material';
import { atom, useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getErrInfo } from './utils';

const Layout = styled.div`
  padding: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const passwordPopupAtom = atom(false);

export default function PopupPasswordChange() {
  const { t } = useTranslation();

  const [password, setPassword] = useState<string>();
  const [{ data, mutate, status, error }] = useAtom(passwordChangeAtom);
  const [open, setOpen] = useAtom(passwordPopupAtom);

  useEffect(() => {
    if (data && status) {
      setOpen(false);
    } else if (status === 'error' && error) {
      const errInfo = getErrInfo(error);
      if (errInfo.commonMsgKey !== '') {
        alert(t(errInfo.commonMsgKey) + '\n' + errInfo.statusCode + '\n' + errInfo.headerCode);
      }
    }
  }, [data, status]);

  const handleCloseClick = (): void => {
    mutate(password);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <Layout>
        <TextField
          id="Password"
          label="Password"
          variant="standard"
          type="password"
          fullWidth={true}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          variant="contained"
          sx={{
            ...buttonBaseStyle,
            width: 300,
            height: 44,
            borderRadius: 22,
          }}
          color="info"
          onClick={handleCloseClick}
        >
          <Typography fontWeight="medium">{t('Common.label.registButton')}</Typography>
        </Button>
      </Layout>
    </Dialog>
  );
}
